export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.
    PlanNotFromReservationsService: 'specs.seatings.ui.PlanNotFromReservationsService',
    DisableRicos: 'specs.events.ui.DisableRicos',
    SausageIntegration: 'specs.events.ui.SausageIntegration', // false 100%, 2024-11-08
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting', // English 100%, 2024-11-08
    AiAssistant: 'specs.events.ui.AiEventsAssistant',
    AiEventsQaAssistant: 'specs.events.ui.AiEventsQaAssistant',
    AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
    AiTicketsQaAssistant: 'specs.events.ui.AiTicketsQaAssistant',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    PlanTicketsDesign: 'specs.events.ui.PlanTicketsDesign',
    UpdateSettingsPanelIllustrations: 'specs.events.ui.UpdateSettingsPanelIllustrations',
    DisableMobileFontOverrides: 'specs.events.ui.DisableMobileFontOverrides',
    UpdateGuestEmail: 'specs.events.ui.UpdateGuestEmail',
    UseGuestsService: 'specs.events.ui.UseGuestsService', // false 100%, 2024-11-08
    WixLiveTerminationWarnings: 'specs.events.ui.WixLiveTerminationWarnings',
    StudioCompatibility: 'specs.events.ui.StudioCompatibility',
    AddEditRegistrationFormStep: 'specs.events.ui.AddEditRegistrationFormStep', // false 100%, 2024-11-08
    SettingsCheckoutFormContent: 'specs.events.ui.SettingsCheckoutFormContent',
    DelayedPayments: 'specs.events.ui.DelayedPaymentCapture',
    SeatCategoryAssignment: 'specs.events.ui.SeatCategoryAssignment',
    TicketDefinitionNamePrefilled: 'specs.events.ui.TicketDefinitionNamePrefilled',
    StudioCompatibilitySettingsPanels: 'specs.events.ui.StudioCompatibilitySettingsPanels',
    SeatingCardRedesign: 'specs.events.ui.SeatingCardRedesign',
    CssPerBreakpointIndications: 'specs.events.ui.CssPerBreakpointIndications',
    GiftCardsEntryPoint: 'specs.events.ui.GiftCardsEntryPoint',
    GiftCardsViewer: 'specs.events.ui.GiftCardsViewer',
    NewStaffPermissions: 'specs.events.ui.NewStaffPermissions',
    GiftCardsContentUpdates: 'specs.events.ui.GiftCardsContentUpdates',
    SeatSelectionAnnouncement: 'specs.seatings.ui.SeatSelectionAnnouncement',
    DisableLoginHandlerOnInit: 'specs.events.ui.DisableLoginHandlerOnInit',
    TicketErrorToasts: 'specs.events.ui.TicketErrorToasts',
};
//# sourceMappingURL=experiments.js.map